export const LAST_VISITED_PLP_SLUG = "LAST_VISITED_PLP_SLUG";
export const LAST_VISITED_ALP_SLUG = "LAST_VISITED_ALP_SLUG";
export const LAST_VISITED_ATP_SLUG = "LAST_VISITED_ATP_SLUG";

export const IS_NEXT_ROUTE = "is_next_route";
export const SHOPPING_BAG_SCROLL = "__shopping_bag_scroll";

export const STORE_LOCATOR_SEARCH_TEXT = "store_locator_search_text";
